<template>
  <div>
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <div class="studio-page-administrator-content">
      <div class="custom-table-search">
        <v-server-table
          v-show="load_first"
          ref="positionServer"
          :columns="columns"
          :options="table_options"
          class="jTable"
          @loading="loading"
          @loaded="loaded">

          <div
            slot="beforeFilter"
            class="custom-search">
            <b-form inline>
              <b-button
                class="btn grey btn-import-form m__r--5"
                @click="showModal">
                <i class="fa fa-plus fa-lg"/> Add
              </b-button>
              <!-- <b-button
                class="btn grey btn-import-form m__r--5">
                <i class="fa fa-cloud-upload fa-lg"/> Import
              </b-button> -->
              <!-- <b-button
                class="btn grey btn-import-form m__r--5"
                @click="exportPositionToEmail">
                <i class="fa fa-download fa-lg"/> Export
              </b-button> -->
              <span/>
              <b-form
                inline
                @keypress.13.prevent="filter(filter_data)">
                <j-select
                  v-model="select_type"
                  :options="options_search"
                  placeholder="Filter By"
                  class="m__r--5"/>
                <span/>
                <b-form-input
                  ref="filterInput"
                  v-model="filter_data"
                  placeholder="Search"
                  style="width: 250px !important"/>
              </b-form>
            </b-form>
          </div>

          <div
            slot="id"
            slot-scope="props"
            @click="rowClick(props)">
            {{ props.row.id }}
          </div>

          <div
            slot="code"
            slot-scope="props"
            @click="rowClick(props)">
            {{ props.row.code }}
          </div>

          <div
            slot="name"
            slot-scope="props"
            @click="rowClick(props)">
            {{ props.row.name }}
          </div>
          <div
            slot="divisions"
            slot-scope="props"
            @click="rowClick(props)">
            {{ props.row.divisions.map((division)=>{
              return division.name
            }).join() }}
          </div>
          <div
            slot="created_date"
            slot-scope="props"
            @click="rowClick(props)">
            {{ props.row.created_date }}
          </div>
          <div
            slot="updated_date"
            slot-scope="props"
            @click="rowClick(props)">
            {{ props.row.created_date }}
          </div>
          <div
            slot="email"
            slot-scope="props"
            @click="rowClick(props)">
            <div v-if="props.row.user">
              {{ props.row.user.email }}
            </div>
            <div v-else>
              -
            </div>
          </div>
        </v-server-table>
        <jLoadingTable v-if="!load_first"/>
      </div>
    </div>
    <j-position-create
      v-if="isModalOpen"
      @closemodal="closeModal"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import jApiPosition from '@/services/jApiPosition';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import JPositionCreate from '@/views/position/jPositionCreate';
// import jProgressScreen from '@/components/progress-screen/jProgressScreen';
// import jPositionImport from '@/views/company/organization/position/jPositionImport';
// import jExportTitle from '@/views/organigram/title/jExportTitle';

export default {
  components: {
    jLoadingTable,
    JPositionCreate,
    // jProgressScreen,
    // jPositionImport,
    // jExportTitle,
  },
  props: {
    oosRoute: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isModalOpen: false,
      filter_data: '',
      select_type: 'position',
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Code',
          value: 'position_id',
        },
        {
          text: 'Name',
          value: 'position',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Unit',
          value: 'division',
        },
      ],
      data_table: [],
      selected_rows: [],
      load_first: false,
      columns: ['id', 'code', 'name', 'email', 'divisions', 'created_date', 'updated_date'],
      table_options: {
        headings: {
          id: 'ID',
          code: 'CODE',
          name: 'NAME',
          email: 'EMAIL',
          divisions: 'UNIT',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        perPage: 10,
        perPageValues: [10, 20, 50, 100],
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        filterable: true,
        sortable: ['id', 'code', 'name', 'created_date'],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : 'created_date',
              ascending: !data.ascending,
              query: data.query ? data.query : '',
            },
          };
        },
        requestFunction(data) {
          const getPositionList = jApiPosition.getListPosition(data);
          return getPositionList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/toggleProblem',
              e.response.data.errors[0].message)
              .bind(this);
          });
        },
        responseAdapter({ data }) {
          data.data.forEach((e) => {
            const div = e.divisions ? e.divisions : [];
            // eslint-disable-next-line
            e.divisions_storage = [...div];
            e.divisions_storage.splice(2);
          });
          if (data.length) {
            this.length_table = data.length;
          }
          return {
            data: data.data || [],
            count: data.length || 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStorePosition', ['position_created', 'position_updated', 'position_deleted']),
    ...mapState('jStoreNotificationScreen', ['loading_screen']),
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },

    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: false },
        { url: '/administrator/position', label: 'POSITION', show: true, active: true },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: false },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: false },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: false },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: false },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: false },
      ];
    },
  },
  watch: {
    filter_data(val) {
      if (val === '' || !val) {
        this.$refs.positionServer.setFilter('');
      }
    },

    position_created() {
      this.refreshTable();
    },
    position_updated() {
      this.refreshTable();
    },
    position_deleted() {
      this.refreshTable();
    },

    selected_rows() {
      if (this.selected_rows.length === 0) {
        this.$refs.actionBar.hide();
      } else {
        this.$refs.actionBar.show();
      }
    },
    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'toggleProblem', 'showLoading', 'hideLoading']),

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.positionServer.getData();
    },

    filter(val) {
      this.$refs.positionServer.setFilter(val);
    },

    rowClick(data) {
    //   const isOOS = window.location.href.includes('pro/officeless');
    //   if (isOOS) {
      // this.$router.push(`${this.oosRoute}/position/update/${data.row.id}`);
    //   } else {
      this.$router.push(`/administrator/position/update/${data.row.id}`);
    //   }
    },

    generateUrl() {
      const isOOS = window.location.href.includes('pro/officeless');
      if (isOOS) {
        this.$router.push(`${this.oosRoute}/position/create`);
      } else {
        this.$router.push('/company/organization/position/create');
      }
    },

    finish() {
      this.refreshTable();
      this.selected_rows = [];
    },

    getToday() {
      const today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      const yyyy = today.getFullYear();
      if (dd < 10) {
        dd = `0${dd}`;
      }

      if (mm < 10) {
        mm = `0${mm}`;
      }

      return `${yyyy}-${mm}-${dd}`;
    },

    exportPositionToEmail() {
      const req = {
        type: 'xls',
        send_mail_type: 1,
      };
      this.$store.dispatch('jStoreOrganigram/exportPositionToEmail', req);
    },
    showModal() {
      if (!this.isModalOpen) {
        this.isModalOpen = true;
      }
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>

<style scoped>
.header-position{
    padding: 20px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F1;
}
.body-position{
    background-color: #FCFDFE;
    padding: 30px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    border: 1px solid #F1F1F1;
}
</style>



// WEBPACK FOOTER //
// src/views/position/jPositionList.vue